// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_loginPage__YDMOP {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow: hidden;
  background: var(--bg-base);
}

.Login_loginBg__o9Afh {
  position: absolute;
  inset: 0;
  z-index: 0;
  background: linear-gradient(135deg, #1e1b4b 0%, #0f1226 50%, #102a3a 100%);
}

.Login_blob__6Mzu\\+ {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.55;
  will-change: transform;
}

.Login_blob1__q0Kd2 {
  width: 480px; height: 480px;
  background: radial-gradient(circle, #3b82f6, transparent 70%);
  top: -120px; left: -100px;
  animation: Login_drift1__pdr9a 18s ease-in-out infinite;
}

.Login_blob2__KGJGC {
  width: 420px; height: 420px;
  background: radial-gradient(circle, #06b6d4, transparent 70%);
  bottom: -140px; right: -80px;
  animation: Login_drift2__iuLs0 22s ease-in-out infinite;
}

.Login_blob3__DzJmE {
  width: 380px; height: 380px;
  background: radial-gradient(circle, #0ea5e9, transparent 70%);
  top: 40%; left: 50%;
  animation: Login_drift3__HkpK- 20s ease-in-out infinite;
}

@keyframes Login_drift1__pdr9a {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50%      { transform: translate(120px, 80px) scale(1.15); }
}
@keyframes Login_drift2__iuLs0 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50%      { transform: translate(-100px, -90px) scale(1.1); }
}
@keyframes Login_drift3__HkpK- {
  0%, 100% { transform: translate(-50%, 0) scale(1); }
  50%      { transform: translate(-50%, -70px) scale(1.2); }
}

.Login_loginContainer__yjP6k {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  animation: Login_fadeIn__jfmDj 0.5s ease-out;
}

@keyframes Login_fadeIn__jfmDj {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

.Login_loginCard__vtDVV {
  background: rgba(255, 255, 255, 0.08) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);
  padding: 44px 38px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.Login_loginCard__vtDVV:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 56px rgba(0, 0, 0, 0.45);
}

.Login_loginCard__vtDVV .ant-card-body {
  padding: 0;
}

.Login_loginHeader__s5T6s {
  text-align: center;
  margin-bottom: 32px;
}

.Login_loginLogo__y6de3 {
  width: 60px; height: 60px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: linear-gradient(135deg, #3b82f6, #06b6d4);
  color: #fff;
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.4);
  animation: Login_float__Vn9bG 4s ease-in-out infinite;
}

.Login_loginLogo__y6de3 svg { width: 30px; height: 30px; }

@keyframes Login_float__Vn9bG {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-6px); }
}

.Login_loginTitle__fFev\\+ {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 8px 0;
  letter-spacing: -0.3px;
}

.Login_loginSubtitle__5MUNC {
  color: rgba(255, 255, 255, 0.6);
  font-size: 15px;
  margin: 0;
  font-weight: 400;
}

.Login_loginAlert__Iuoz4 {
  margin-bottom: 24px;
  border-radius: 10px;
}

.Login_inputIcon__K1W83 {
  display: inline-flex;
  width: 18px; height: 18px;
  color: rgba(255, 255, 255, 0.5);
}

.Login_inputIcon__K1W83 svg { width: 100%; height: 100%; }

.Login_loginPage__YDMOP .ant-form-item {
  margin-bottom: 20px;
}

.Login_loginPage__YDMOP .ant-input-affix-wrapper,
.Login_loginPage__YDMOP .ant-input {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  background: rgba(255, 255, 255, 0.06) !important;
  transition: all 0.25s ease;
  font-size: 15px;
  padding: 11px 14px;
  color: #fff !important;
}

.Login_loginPage__YDMOP .ant-input-affix-wrapper input.ant-input {
  background: transparent !important;
  border: none !important;
  padding: 0;
}

.Login_loginPage__YDMOP .ant-input::placeholder,
.Login_loginPage__YDMOP .ant-input-affix-wrapper input::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}

.Login_loginPage__YDMOP .ant-input-affix-wrapper:hover,
.Login_loginPage__YDMOP .ant-input:hover {
  border-color: rgba(255, 255, 255, 0.3) !important;
  background: rgba(255, 255, 255, 0.09) !important;
}

.Login_loginPage__YDMOP .ant-input-affix-wrapper-focused,
.Login_loginPage__YDMOP .ant-input-affix-wrapper:focus-within {
  border-color: #60a5fa !important;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.25) !important;
  background: rgba(255, 255, 255, 0.1) !important;
}

.Login_loginPage__YDMOP .ant-input-prefix {
  margin-right: 10px;
}

.Login_loginPage__YDMOP input:-webkit-autofill,
.Login_loginPage__YDMOP input:-webkit-autofill:hover,
.Login_loginPage__YDMOP input:-webkit-autofill:focus,
.Login_loginPage__YDMOP input:-webkit-autofill:active {
  -webkit-text-fill-color: #ffffff !important;
  box-shadow: 0 0 0 1000px #1c2030 inset !important;
  caret-color: #ffffff;
  border-radius: 12px;
  -webkit-transition: background-color 9999s ease-in-out 0s !important;
  transition: background-color 9999s ease-in-out 0s !important;
}

.Login_loginPage__YDMOP .ant-input-password-icon,
.Login_loginPage__YDMOP .ant-input-password-icon svg,
.Login_loginPage__YDMOP .ant-input-affix-wrapper .anticon {
  color: rgba(255, 255, 255, 0.5) !important;
}

.Login_loginPage__YDMOP .ant-input-password-icon:hover,
.Login_loginPage__YDMOP .ant-input-password-icon:hover svg {
  color: rgba(255, 255, 255, 0.85) !important;
}

.Login_loginOptions__8nobr {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Login_loginPage__YDMOP .ant-checkbox-wrapper {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.Login_loginPage__YDMOP .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

.Login_loginPage__YDMOP .ant-checkbox:hover .ant-checkbox-inner {
  border-color: #60a5fa;
}

.Login_loginPage__YDMOP .ant-btn-primary {
  height: 46px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #3b82f6, #0891b2);
  background-size: 200% 200%;
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
  transition: all 0.3s ease;
}

.Login_loginPage__YDMOP .ant-btn-primary:hover {
  background-position: right center;
  box-shadow: 0 8px 28px rgba(59, 130, 246, 0.55);
  transform: translateY(-1px);
}

.Login_loginPage__YDMOP .ant-btn-primary:active {
  transform: translateY(0) scale(0.99);
}

.Login_loginPage__YDMOP .ant-btn-loading {
  opacity: 0.8;
}

.Login_loginFooter__75Mk3 {
  text-align: center;
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.Login_loginFooterText__G8VYW {
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
  margin: 0;
}

.Login_loginLoader__S6zC0 {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 18, 38, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  animation: Login_loaderFade__dLcs4 0.3s ease-out;
}

@keyframes Login_loaderFade__dLcs4 {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.Login_loginLoaderText__QFN37 {
  display: flex;
  gap: 16px;
  font-size: 38px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.Login_loginLoaderText__QFN37 span {
  background: linear-gradient(90deg, #3b82f6, #06b6d4, #0ea5e9, #3b82f6);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  opacity: 0;
  animation: Login_wordIn__Hc1LT 0.6s ease-out forwards, Login_shimmer__V5seN 3s linear infinite;
}

.Login_loginLoaderText__QFN37 span:nth-child(2) {
  animation-delay: 0.25s, 0s;
}

@keyframes Login_wordIn__Hc1LT {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes Login_shimmer__V5seN {
  to { background-position: -300% 0; }
}

@media (max-width: 576px) {
  .Login_loginCard__vtDVV { padding: 32px 24px; }
  .Login_loginTitle__fFev\\+ { font-size: 21px; }
  .Login_loginSubtitle__5MUNC { font-size: 14px; }
  .Login_blob__6Mzu\\+ { filter: blur(60px); }
}

@media (prefers-reduced-motion: reduce) {
  .Login_blob__6Mzu\\+, .Login_loginLogo__y6de3, .Login_loginContainer__yjP6k { animation: none; }
}`, "",{"version":3,"sources":["webpack://./src/pages/Auth/Login.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,6DAA6D;EAC7D,WAAW,EAAE,YAAY;EACzB,uDAA0C;AAC5C;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,6DAA6D;EAC7D,cAAc,EAAE,YAAY;EAC5B,uDAA0C;AAC5C;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,6DAA6D;EAC7D,QAAQ,EAAE,SAAS;EACnB,uDAA0C;AAC5C;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,WAAW,6CAA6C,EAAE;AAC5D;AACA;EACE,WAAW,mCAAmC,EAAE;EAChD,WAAW,8CAA8C,EAAE;AAC7D;AACA;EACE,WAAW,sCAAsC,EAAE;EACnD,WAAW,4CAA4C,EAAE;AAC3D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,4CAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,sDAAsD;EACtD,0CAA0C;EAC1C,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,8CAA8C;EAC9C,qDAAwC;AAC1C;;AAEA,8BAAiB,WAAW,EAAE,YAAY,EAAE;;AAE5C;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,2BAA2B,EAAE;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW,EAAE,YAAY;EACzB,+BAA+B;AACjC;;AAEA,8BAAiB,WAAW,EAAE,YAAY,EAAE;;AAE5C;EACE,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,sDAAsD;EACtD,gDAAgD;EAChD,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,iDAAiD;EACjD,gDAAgD;AAClD;;AAEA;;EAEE,gCAAgC;EAChC,yDAAyD;EACzD,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,2CAA2C;EAE3C,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,oEAA4D;EAA5D,4DAA4D;AAC9D;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,0BAA0B;EAC1B,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,gDAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sEAAsE;EACtE,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,UAAU;EACV,8FAAoE;AACtE;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,0BAAa,kBAAkB,EAAE;EACjC,4BAAc,eAAe,EAAE;EAC/B,8BAAiB,eAAe,EAAE;EAClC,sBAAQ,kBAAkB,EAAE;AAC9B;;AAEA;EACE,6EAAqC,eAAe,EAAE;AACxD","sourcesContent":[".loginPage {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  overflow: hidden;\n  background: var(--bg-base);\n}\n\n.loginBg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  background: linear-gradient(135deg, #1e1b4b 0%, #0f1226 50%, #102a3a 100%);\n}\n\n.blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.55;\n  will-change: transform;\n}\n\n.blob1 {\n  width: 480px; height: 480px;\n  background: radial-gradient(circle, #3b82f6, transparent 70%);\n  top: -120px; left: -100px;\n  animation: drift1 18s ease-in-out infinite;\n}\n\n.blob2 {\n  width: 420px; height: 420px;\n  background: radial-gradient(circle, #06b6d4, transparent 70%);\n  bottom: -140px; right: -80px;\n  animation: drift2 22s ease-in-out infinite;\n}\n\n.blob3 {\n  width: 380px; height: 380px;\n  background: radial-gradient(circle, #0ea5e9, transparent 70%);\n  top: 40%; left: 50%;\n  animation: drift3 20s ease-in-out infinite;\n}\n\n@keyframes drift1 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50%      { transform: translate(120px, 80px) scale(1.15); }\n}\n@keyframes drift2 {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  50%      { transform: translate(-100px, -90px) scale(1.1); }\n}\n@keyframes drift3 {\n  0%, 100% { transform: translate(-50%, 0) scale(1); }\n  50%      { transform: translate(-50%, -70px) scale(1.2); }\n}\n\n.loginContainer {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 420px;\n  animation: fadeIn 0.5s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(16px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.loginCard {\n  background: rgba(255, 255, 255, 0.08) !important;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);\n  padding: 44px 38px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.loginCard:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 16px 56px rgba(0, 0, 0, 0.45);\n}\n\n.loginCard :global(.ant-card-body) {\n  padding: 0;\n}\n\n.loginHeader {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.loginLogo {\n  width: 60px; height: 60px;\n  margin: 0 auto 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #3b82f6, #06b6d4);\n  color: #fff;\n  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.4);\n  animation: float 4s ease-in-out infinite;\n}\n\n.loginLogo svg { width: 30px; height: 30px; }\n\n@keyframes float {\n  0%, 100% { transform: translateY(0); }\n  50%      { transform: translateY(-6px); }\n}\n\n.loginTitle {\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 8px 0;\n  letter-spacing: -0.3px;\n}\n\n.loginSubtitle {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 15px;\n  margin: 0;\n  font-weight: 400;\n}\n\n.loginAlert {\n  margin-bottom: 24px;\n  border-radius: 10px;\n}\n\n.inputIcon {\n  display: inline-flex;\n  width: 18px; height: 18px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.inputIcon svg { width: 100%; height: 100%; }\n\n.loginPage :global(.ant-form-item) {\n  margin-bottom: 20px;\n}\n\n.loginPage :global(.ant-input-affix-wrapper),\n.loginPage :global(.ant-input) {\n  border-radius: 12px !important;\n  border: 1px solid rgba(255, 255, 255, 0.15) !important;\n  background: rgba(255, 255, 255, 0.06) !important;\n  transition: all 0.25s ease;\n  font-size: 15px;\n  padding: 11px 14px;\n  color: #fff !important;\n}\n\n.loginPage :global(.ant-input-affix-wrapper) input:global(.ant-input) {\n  background: transparent !important;\n  border: none !important;\n  padding: 0;\n}\n\n.loginPage :global(.ant-input)::placeholder,\n.loginPage :global(.ant-input-affix-wrapper) input::placeholder {\n  color: rgba(255, 255, 255, 0.4) !important;\n}\n\n.loginPage :global(.ant-input-affix-wrapper):hover,\n.loginPage :global(.ant-input):hover {\n  border-color: rgba(255, 255, 255, 0.3) !important;\n  background: rgba(255, 255, 255, 0.09) !important;\n}\n\n.loginPage :global(.ant-input-affix-wrapper-focused),\n.loginPage :global(.ant-input-affix-wrapper):focus-within {\n  border-color: #60a5fa !important;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.25) !important;\n  background: rgba(255, 255, 255, 0.1) !important;\n}\n\n.loginPage :global(.ant-input-prefix) {\n  margin-right: 10px;\n}\n\n.loginPage input:-webkit-autofill,\n.loginPage input:-webkit-autofill:hover,\n.loginPage input:-webkit-autofill:focus,\n.loginPage input:-webkit-autofill:active {\n  -webkit-text-fill-color: #ffffff !important;\n  -webkit-box-shadow: 0 0 0 1000px #1c2030 inset !important;\n  box-shadow: 0 0 0 1000px #1c2030 inset !important;\n  caret-color: #ffffff;\n  border-radius: 12px;\n  transition: background-color 9999s ease-in-out 0s !important;\n}\n\n.loginPage :global(.ant-input-password-icon),\n.loginPage :global(.ant-input-password-icon) svg,\n.loginPage :global(.ant-input-affix-wrapper) :global(.anticon) {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.loginPage :global(.ant-input-password-icon):hover,\n.loginPage :global(.ant-input-password-icon):hover svg {\n  color: rgba(255, 255, 255, 0.85) !important;\n}\n\n.loginOptions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.loginPage :global(.ant-checkbox-wrapper) {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n}\n\n.loginPage :global(.ant-checkbox-checked) :global(.ant-checkbox-inner) {\n  background-color: #3b82f6;\n  border-color: #3b82f6;\n}\n\n.loginPage :global(.ant-checkbox):hover :global(.ant-checkbox-inner) {\n  border-color: #60a5fa;\n}\n\n.loginPage :global(.ant-btn-primary) {\n  height: 46px;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 12px;\n  border: none;\n  background: linear-gradient(135deg, #3b82f6, #0891b2);\n  background-size: 200% 200%;\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n  transition: all 0.3s ease;\n}\n\n.loginPage :global(.ant-btn-primary):hover {\n  background-position: right center;\n  box-shadow: 0 8px 28px rgba(59, 130, 246, 0.55);\n  transform: translateY(-1px);\n}\n\n.loginPage :global(.ant-btn-primary):active {\n  transform: translateY(0) scale(0.99);\n}\n\n.loginPage :global(.ant-btn-loading) {\n  opacity: 0.8;\n}\n\n.loginFooter {\n  text-align: center;\n  margin-top: 28px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.loginFooterText {\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 14px;\n  margin: 0;\n}\n\n.loginLoader {\n  position: absolute;\n  inset: 0;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 18, 38, 0.55);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  animation: loaderFade 0.3s ease-out;\n}\n\n@keyframes loaderFade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.loginLoaderText {\n  display: flex;\n  gap: 16px;\n  font-size: 38px;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n}\n\n.loginLoaderText span {\n  background: linear-gradient(90deg, #3b82f6, #06b6d4, #0ea5e9, #3b82f6);\n  background-size: 300% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  opacity: 0;\n  animation: wordIn 0.6s ease-out forwards, shimmer 3s linear infinite;\n}\n\n.loginLoaderText span:nth-child(2) {\n  animation-delay: 0.25s, 0s;\n}\n\n@keyframes wordIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes shimmer {\n  to { background-position: -300% 0; }\n}\n\n@media (max-width: 576px) {\n  .loginCard { padding: 32px 24px; }\n  .loginTitle { font-size: 21px; }\n  .loginSubtitle { font-size: 14px; }\n  .blob { filter: blur(60px); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .blob, .loginLogo, .loginContainer { animation: none; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginPage": `Login_loginPage__YDMOP`,
	"loginBg": `Login_loginBg__o9Afh`,
	"blob": `Login_blob__6Mzu+`,
	"blob1": `Login_blob1__q0Kd2`,
	"drift1": `Login_drift1__pdr9a`,
	"blob2": `Login_blob2__KGJGC`,
	"drift2": `Login_drift2__iuLs0`,
	"blob3": `Login_blob3__DzJmE`,
	"drift3": `Login_drift3__HkpK-`,
	"loginContainer": `Login_loginContainer__yjP6k`,
	"fadeIn": `Login_fadeIn__jfmDj`,
	"loginCard": `Login_loginCard__vtDVV`,
	"loginHeader": `Login_loginHeader__s5T6s`,
	"loginLogo": `Login_loginLogo__y6de3`,
	"float": `Login_float__Vn9bG`,
	"loginTitle": `Login_loginTitle__fFev+`,
	"loginSubtitle": `Login_loginSubtitle__5MUNC`,
	"loginAlert": `Login_loginAlert__Iuoz4`,
	"inputIcon": `Login_inputIcon__K1W83`,
	"loginOptions": `Login_loginOptions__8nobr`,
	"loginFooter": `Login_loginFooter__75Mk3`,
	"loginFooterText": `Login_loginFooterText__G8VYW`,
	"loginLoader": `Login_loginLoader__S6zC0`,
	"loaderFade": `Login_loaderFade__dLcs4`,
	"loginLoaderText": `Login_loginLoaderText__QFN37`,
	"wordIn": `Login_wordIn__Hc1LT`,
	"shimmer": `Login_shimmer__V5seN`
};
export default ___CSS_LOADER_EXPORT___;
